/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
    var container,
        button,
        menu,
        links,
        i,
        len;
    var windowWidth = window.innerWidth;
    // var mastheadHeight = jQuery('header#masthead').outerHeight();

    var loc = window.location;
    var url = loc.protocol + '//' + loc.host + loc.pathname;

    container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    button = document.getElementById('menu-action');
    if (!container) {
        return;
    }

    menu = container.getElementsByTagName('ul')[0];

    // Hide menu toggle button if menu is empty and return early.
    if ('undefined' === typeof menu) {
        button.style.display = 'none';
        return;
    }

    menu.setAttribute('aria-expanded', 'false');
    if (-1 === menu.className.indexOf('nav-menu')) {
        menu.className += ' nav-menu';
    }

    button.onclick = function () {
        if (-1 !== container.className.indexOf('toggled')) {
            if (jQuery('.ppir-subscription').hasClass('toggled')) {
                jQuery('.ppir-subscription').stop(true, true).fadeOut(300).removeClass('toggled');
                window.history.pushState({ path: url }, '', url);
            }
            else {
                container.className = container.className.replace(' toggled', '');
                button.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-expanded', 'false');
                jQuery('.menu-container').attr('style', '');
                // window.removeEventListener('scroll', ngPreventMotion, false);
                // window.removeEventListener('touchmove', ngPreventMotion, false);
            }
        } else {
            container.className += ' toggled';
            button.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-expanded', 'true');
            jQuery('.menu-container').css({'top': jQuery('header#masthead').outerHeight() + 'px'});
            // window.addEventListener('scroll', ngPreventMotion, false);
            // window.addEventListener('touchmove', ngPreventMotion, false);
        }
    };

    // Get all the link elements within the menu.
    links = menu.getElementsByTagName('a');

    // Each time a menu link is focused or blurred, toggle focus.
    for (i = 0, len = links.length; i < len; i++) {
        links[i].addEventListener('focus', toggleFocus, true);
        links[i].addEventListener('blur', toggleFocus, true);
    }

    function ngPreventMotion(event) {
        window.scrollTo(0, 0);
        event.preventDefault();
        event.stopPropagation();
    }

    /**
     * Sets or removes .focus class on an element.
     */
    function toggleFocus() {
        var self = this;

        // Move up through the ancestors of the current link until we hit .nav-menu.
        while (-1 === self.className.indexOf('nav-menu')) {

            // On li elements toggle the class .focus.
            if ('li' === self.tagName.toLowerCase()) {
                if (-1 !== self.className.indexOf('focus')) {
                    self.className = self.className.replace(' focus', '');
                } else {
                    self.className += ' focus';
                }
            }

            self = self.parentElement;
        }
    }

    /**
     * Toggles `focus` class to allow submenu access on tablets.
     */
    (function (container) {
        var touchStartFn,
            i,
            parentLink = container.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

        if ('ontouchstart' in window) {
            touchStartFn = function (e) {
                var menuItem = this.parentNode,
                    i;

                if (!menuItem.classList.contains('focus')) {
                    e.preventDefault();
                    for (i = 0; i < menuItem.parentNode.children.length; ++i) {
                        if (menuItem === menuItem.parentNode.children[i]) {
                            continue;
                        }
                        menuItem.parentNode.children[i].classList.remove('focus');
                    }
                    menuItem.classList.add('focus');
                } else {
                    menuItem.classList.remove('focus');
                }
            };

            for (i = 0; i < parentLink.length; ++i) {
                parentLink[i].addEventListener('touchstart', touchStartFn, false);
            }
        }
    }(container));

    jQuery(window).resize(function () {
        windowWidth = window.innerWidth;
        mastheadHeight = jQuery('header#masthead').outerHeight();
        if (windowWidth > 992) {
            container.className = container.className.replace(' toggled', '');
            button.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-expanded', 'false');
            jQuery('.menu-container').attr('style', '');
            // window.removeEventListener('scroll', ngPreventMotion, false);
            // window.removeEventListener('touchmove', ngPreventMotion, false);
        }

        if(jQuery('.main-navigation').hasClass('toggled')) {
            jQuery('.menu-container').css({'top': mastheadHeight + 'px'});
        }
    });
})();
